<template>
  <div>
      <div class="items flex-row flex-wrap" v-for="(item, key) in entity.leftItems" :key="key">
        <div class="flex-row align-items-center">
          <div>
            {{key + 1}}. &nbsp;
          </div>
          <pinyin v-if="typeData.leftItems == 'words_pinyin'" :text="item.text" :pinyin="item.pinyin"></pinyin>
          <div v-else-if="typeData.leftItems == 'words'">
            {{item.text}}
          </div>
<!--          <pinyin v-else-if="typeData.leftItems == 'line' && typeData.leftPinyin" :text="item.text" :pinyin="item.pinyin"></pinyin>-->
<!--          <div v-else-if="typeData.leftItems == 'line'">-->
<!--            {{item.text}}-->
<!--          </div>-->
          <div v-else-if="typeData.leftItems == 'pinyin'">
            {{item.pinyin}}
          </div>
          <div v-else-if="typeData.leftItems == 'translation'">
            {{item.translation}}
          </div>
          <ImageView v-else-if="typeData.leftItems == 'image'" :src="item.image" :desc="item.imageDesc"></ImageView>
          <AudioView v-else-if="typeData.leftItems == 'audio'" :src="item.audio"></AudioView>
          <div v-else>
            {{item.text}}
          </div>
        </div>
        <div class="flex-row align-items-center pdt-line"></div>
        <div class="flex-row align-items-center">
          <pinyin v-if="typeData.rightItems == 'words_pinyin'" :text="entity.rightItems[key].text" :pinyin="entity.rightItems[key].pinyin"></pinyin>
          <div v-else-if="typeData.rightItems == 'words'">
            {{entity.rightItems[key].text}}
          </div>
<!--          <pinyin v-else-if="typeData.rightItems == 'line' && typeData.rightPinyin" :text="item.text" :pinyin="entity.rightItems[key].pinyin"></pinyin>-->
<!--          <div v-else-if="typeData.rightItems == 'line'">-->
<!--            {{entity.rightItems[key].text}}-->
<!--          </div>-->
          <div v-else-if="typeData.rightItems == 'pinyin'">
            {{entity.rightItems[key].pinyin}}
          </div>
          <div v-else-if="typeData.rightItems == 'translation'">
            {{entity.rightItems[key].translation}}
          </div>
          <ImageView v-else-if="typeData.rightItems == 'image'" :src="entity.rightItems[key].image" :desc="entity.rightItems[key].imageDesc"></ImageView>
          <AudioView v-else-if="typeData.rightItems == 'audio'" :src="entity.rightItems[key].audio"></AudioView>
          <div v-else>
            {{entity.rightItems[key].text}}
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import ImageView from './../../ImageView'
import AudioView from './../../AudioView'
import pinyin from './../../PinyinPreview'

export default {
  name: 'PdtView',
  components: { pinyin, ImageView, AudioView },
  props: {
    type: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  watch: {
    'type': {
      deep:true,
      handler(entity) {
        this.typeData = JSON.parse(this.type.data_json);
      }
    }
  },
  data () {
    return {
      typeData: {},
    }
  },
  created() {
    this.typeData = JSON.parse(this.type.data_json);
  },
}
</script>

<style lang="scss">
  .exr-pdt{
    .items{
      margin: -5px 20px -5px -5px;
      > div{
        margin: 5px;
      }
    }
  }
  .exr-theme-line{
    >.exr-content{
      display: flex;
      align-items: center;
      > div + div {
        margin-left: 5px;
      }
    }
    img{
      max-height: 50px;
    }
  }
  .answered{
    color: #409EFF;
  }
  .pdt-line {
    margin: 5px 15px;
    background-color: #eeeeee;
    width: 2px;
  }
</style>
